import 'bootstrap-datepicker' // Globals: $.datepicker(). Rely on jquery

$('.datepicker_field').datepicker({
  format: 'yyyy-mm-dd',
  autoclose: true,
  isInline: false,
})
